module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_Product_Catering-a73ba32bd899f77e6bc2c680014ef252.jpg";